import { Component, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { faChevronLeft, faChevronRight, faXmark } from '@fortawesome/free-solid-svg-icons';

export interface LightboxItem {
  url: string;
  thumbnailUrl?: string;
  mediaType: 'photo' | 'video';
  title?: string;
}

@Component({
  selector: 'app-lightbox',
  templateUrl: './lightbox.component.html',
  styleUrls: ['./lightbox.component.css'],
  standalone: false
})
export class LightboxComponent {
  @Input() items: LightboxItem[] = [];
  @Input() currentIndex: number = 0;
  @Output() closed = new EventEmitter<void>();

  faChevronLeft = faChevronLeft;
  faChevronRight = faChevronRight;
  faXmark = faXmark;

  get currentItem(): LightboxItem | null {
    return this.items[this.currentIndex] ?? null;
  }

  get hasMultipleItems(): boolean {
    return this.items.length > 1;
  }

  close(): void {
    this.closed.emit();
  }

  previous(): void {
    if (this.currentIndex > 0) {
      this.currentIndex--;
    } else {
      this.currentIndex = this.items.length - 1;
    }
  }

  next(): void {
    if (this.currentIndex < this.items.length - 1) {
      this.currentIndex++;
    } else {
      this.currentIndex = 0;
    }
  }

  onBackdropClick(event: MouseEvent): void {
    if ((event.target as HTMLElement).classList.contains('lightbox-backdrop')) {
      this.close();
    }
  }

  @HostListener('document:keydown', ['$event'])
  handleKeydown(event: KeyboardEvent): void {
    switch (event.key) {
      case 'Escape':
        this.close();
        break;
      case 'ArrowLeft':
        this.previous();
        break;
      case 'ArrowRight':
        this.next();
        break;
    }
  }
}
